<template>
  <!--
          作者：luoyiming
          时间：2019-10-24
          描述：后台系统头部
      -->
  <div class="common-header">
    <div class="breadcrumb">
      <!--一般的标题显示-->
      <div class="baseInfo-left-base d-s-c">
        <span class="name">{{ menu_title }}</span>
        <!--插件切换-->
        <div class="el-tabs-container">
          <el-tabs v-model="activeValue" @tab-click="tabClick">
            <el-tab-pane
              :label="item.value"
              :name="item.key"
              v-for="(item, index) in tabList"
              :key="index"
            ></el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <div class="header-navbar">
        <div class="header-navbar-icon" style="min-width: 50px">
          <span class="gray">当前版本：{{ baseInfo.version }}</span>
        </div>

        <!-- 铃铛提示 -->
        <el-popover placement="bottom" width="200" trigger="hover">
          <div class="content_pop">
            <div v-if="show_point" class="fb orange" style="font-style: italic">
              有新的订单
            </div>
            <div v-else class="gray6" style="font-style: italic">
              暂无
            </div>
          </div>
          <div
            slot="reference"
            class="head-notification mr10 pr"
            style="cursor: pointer;"
            @click="confirmOrder"
          >
            <img
              src="../../assets/img/lindang.png"
              width="20"
              height="20"
              alt=""
            />
            <div class="point pa radius" v-show="show_point"></div>
          </div>
        </el-popover>

        <div class="header-navbar-icon bofang">
          <audio :src="audiosrc" id="audioid" ref="audio">
            当前浏览器不支持audio标签
          </audio>
          <button @click="onplay" style="border: none">
            <img
              src="https://qiniu.haidiao888.com/icon/%E9%9F%B3%E9%A2%91%E6%92%AD%E6%94%BE.png"
              alt=""
              style="width: 20px; height: 20px"
              v-if="imgshow"
            />
            <img
              src="https://qiniu.haidiao888.com/icon/%E6%9A%82%E5%81%9C.png"
              alt=""
              style="width: 20px; height: 20px"
              v-else
            />
          </button>
        </div>

        <div class="header-navbar-icon">
          <span class="ml4 icon iconfont icon-geren9 yingchang"></span>
          <span class="text ml4 blue hyn"
            >{{ baseInfo.user.user_name }}，欢迎您！</span
          >
        </div>
        <div class="header-navbar-icon"><span class="gray">|</span></div>
        <div class="header-navbar-icon mindata" @click="passwordFunc()">
          <span class="text">修改密码</span>
        </div>
        <div class="header-navbar-icon login-out" @click="login_out()">
          <span class="icon iconfont icon-tuichu"></span>
          <span class="text ml4">退出</span>
        </div>
      </div>
    </div>

    <!--修改密码-->
    <UpdatePassword v-if="is_password" @close="closeFunc"></UpdatePassword>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import bus from "@/utils/eventBus.js";
import AuthApi from "@/api/auth.js";
import UserApi from "@/api/user.js";
import IndexApi from "../../api";
import {
  setCookie,
  delCookie,
  getCookie,
  deleteSessionStorage
} from "@/utils/base.js";
import store from "@/store";
import UpdatePassword from "./part/UpdatePassword.vue";
export default {
  components: {
    UpdatePassword
  },
  data() {
    return {
      audiosrc: "https://qiniu.haidiao888.com/icon/%E6%AC%A2%E8%BF%8E.mp3",
      imgshow: true,
      orderTotal: "",
      /*菜单名称*/
      menu_title: "菜单",
      /*切换菜单*/
      tabList: [],
      /*切换选中*/
      activeValue: 0,
      /*是否修改密码*/
      is_password: false,
      /*tab切换类别*/
      tab_type: "",
      /*新订单提示红点*/
      show_point: false,
      /*提示词显示*/
      visible: false,
      new_count: 0
    };
  },
  inject: ["baseInfo"],
  watch: {
    orderTotal: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal);
        if (oldVal != "") {
          if (newVal > oldVal) {
            let self = this;
            self.audio.src =
              "https://qiniu.haidiao888.com/icon/%E6%96%B0%E8%AE%A2%E5%8D%95.mp3";
            console.log("您有新的订单请注意查收,开始播放");
            self.audio.play();
          } else {
            let self = this;
            console.log("停止播放");
            self.audio.pause();
          }
        } else {
          let self = this;
          console.log("停止播放");
          self.audio.pause();
        }
      },
      deep: true
    }
  },
  created() {
    setInterval(() => {
      if (this.baseInfo.role != 4) {
        // console.log("baseInfo",this.baseInfo);
        this.getNewOrder();
      }
    }, 60 * 1000);
    /*监听菜单传过来的值*/
    bus.$on("menuName", res => {
      this.menu_title = res;
    });

    /*监听传插件的值*/
    bus.$on("tabData", res => {
      this.tabList = res.list;
      this.activeValue = res.active;
      this.tab_type = res.tab_type;
    });

    //发送给其它组件头部加载完成
    bus.$emit("headLoad", true);

    this.newOrderNotification();
    //定时获取新的订单信息
    // setInterval(() => {
    //   this.newOrderNotification();
    // }, 30 * 60 * 1000);
    setInterval(() => {
      this.newOrderNotification();
    }, 5 * 1000);
  },
  beforeDestroy() {
    bus.$off("menuName");
    bus.$off("tabData");
  },
  mounted() {
    this.audio = this.$refs.audio;
  },
  methods: {
    // 获取新的订单信息
    getNewOrder() {
      let self = this;
      let Params = {};
      Params.dataType = "examine";
      Params.page = 1;
      Params.list_rows = 20;
      OrderApi.orderlist(Params, true)
        .then(res => {
          self.orderTotal = res.data.list.total;
        })
        .catch(error => {});
    },

    /* 新订单提示 */
    newOrderNotification() {
      const self = this;
      if (this.baseInfo.user) {
        // Api.hasNewOrder(Params, true)
        //   .then(res => {});
        const params = {
          pages: 1,
          list_rows: 20
        };
        IndexApi.getNewList(params, true)
          .then(({ data }) => {
            console.log("新订单数量", data.new_count);
            if (data.new_count > 0) {
              self.show_point = true;
              self.audiosrc =
                "https://qiniu.haidiao888.com/icon/%E6%96%B0%E8%AE%A2%E5%8D%95.mp3";
              self.audio.play(); // 播放音频
              if (self.new_count < data.new_count) {
                self.new_count = data.new_count;
                self.$notify({
                  title: "提示",
                  message: "您有新的订单请注意查收",
                  duration: 0,
                  onClose: () => {
                    self.confirmOrder();
                  }
                });
              }
            }
          })
          .catch(err => console.log(err));
      }
    },

    /* 确认订单 */
    async confirmOrder() {
      const self = this;
      await IndexApi.readAll({}, true);
      if (self.show_point) {
        self.show_point = false;
        self.$message.success("已读");
      }
    },

    onplay() {
      let self = this;
      (self.audiosrc =
        "https://qiniu.haidiao888.com/icon/%E6%AC%A2%E8%BF%8E.mp3"),
        self.audio.play(); // 播放音频
      self.imgshow = !self.imgshow;
    },

    /*退出登录*/
    login_out() {
      this.$confirm("此操作将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          UserApi.loginOut({}, true)
            .then(data => {
              /*删除登录状态*/
              delCookie("isLogin");
              /*删除基本信息*/
              delCookie("baseInfo");
              /*删除用户菜单*/
              deleteSessionStorage("rolelist");
              /*删除用户权限*/
              deleteSessionStorage("authlist");
              /*返回登录页*/
              this.$router.replace({
                path: "/login"
              });
              /*删除stores数据*/
              this.$store.commit("user/setState", {
                key: "roles",
                val: null
              });
              /*刷新页面*/
              location.reload();
            })
            .catch(error => {});
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消退出'
          // });
        });
    },

    /*点击跳转*/
    tabClick(e) {
      /*分销*/
      if (this.tab_type == "agent") {
        this.$router.push({
          path: "/plus/agent/index",
          query: {
            type: e.name
          }
        });
      }
      /*优惠券*/
      if (this.tab_type == "coupon") {
        this.$router.push({
          path: "/plus/coupon/index",
          query: {
            type: e.name
          }
        });
      }
      /*积分商城*/
      if (this.tab_type == "points") {
        this.$router.push({
          path: "/plus/points/index",
          query: {
            type: e.name
          }
        });
      }
      /* 现时秒杀*/
      if (this.tab_type == "seckill") {
        this.$router.push({
          path: "/plus/seckill/index",
          query: {
            type: e.name
          }
        });
      }
      /* 限时拼团*/
      if (this.tab_type == "assemble") {
        this.$router.push({
          path: "/plus/assemble/index",
          query: {
            type: e.name
          }
        });
      }
      /* 砍价*/
      if (this.tab_type == "bargain") {
        this.$router.push({
          path: "/plus/bargain/index",
          query: {
            type: e.name
          }
        });
      }
      /*门店*/
      if (this.tab_type == "store") {
        this.$router.push({
          path: "/store/index",
          query: {
            type: e.name
          }
        });
      }
      /*app设置*/
      if (this.tab_type == "appopen") {
        this.$router.push({
          path: "/appsetting/appopen/event",
          query: {
            type: e.name
          }
        });
      }
      bus.$emit("activeValue", this.activeValue);
    },

    /*修改密码*/
    passwordFunc() {
      this.is_password = true;
    },

    /*关闭修改密码*/
    closeFunc() {
      this.is_password = false;
    }
  }
};
</script>

<style lang="scss">
.common-header .el-tabs__nav-wrap::after {
  display: none;
}

.common-header .el-tabs-container {
  // margin-left: 20px;
  // padding-left: 20px;
  border-left: 1px solid #eeeeee;
}

.common-header .el-tabs__header {
  margin-bottom: 0;
}

.login-out .icon-tuichu {
  color: red;
}

.header-navbar-icon .icon-geren9 {
  font-size: 20px;
}

@media screen and (max-width: 420px) {
  .gray {
    display: none;
  }

  .header-navbar-icon .bofang {
    display: none;
  }

  .header-navbar-icon .yingchang {
    display: none;
  }

  .header-navbar-icon {
    padding-top: 20px;
  }

  .baseInfo-left-base {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Head.vue